import type { SVGProps } from 'react'

export const DriveFileMoveIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21H362q14.46 0 27.81 5.62 13.34 5.61 23.19 15.46L471.92-700h315.77Q818-700 839-679q21 21 21 51.31v375.38Q860-222 839-201q-21 21-51.31 21H172.31Zm339.54-230-49.7 49.69q-8.3 8.31-8.5 20.89-.19 12.57 8.5 21.27 8.7 8.69 21.08 8.69 12.39 0 21.08-8.69l96.54-96.54q10.84-10.85 10.84-25.31 0-14.46-10.84-25.31l-96.54-96.54q-8.31-8.3-20.89-8.5-12.57-.19-21.27 8.5-8.69 8.7-8.69 21.08 0 12.39 8.69 21.08l49.7 49.69h-148q-12.77 0-21.39 8.62-8.61 8.61-8.61 21.38t8.61 21.38q8.62 8.62 21.39 8.62h148Z" />
    </svg>
  )
}
